export default {
	"title": "Preciso de suporte",
	"image": "Capturas de tela",
	"email": "Email",
	"name": "Nome",
	"placeholder": "Você pode descrever seus problemas ou compartilhar suas ideias conosco aqui",
	"desc": "Seu feedback será tratado o mais rápido possível.",
	"submit": "Enviar",
}
